import ProgressBarV3 from "./progress-bar-v3"

export default ProgressBarV3
